import React from "react";

class TextImage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loaded: "",
      dimensionsSet: false
    };
  }

  componentDidMount() {
    // Set element to initially NOT loaded
    this.props.onVerifyElementLoaded(false);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.url !== this.props.url) {
      this.setState({
        loaded: "",
        dimensionsSet: false
      });
    }
  }

  handleOnLoad = () => {
    this.setState({ loaded: "loaded" });
    this.handleImageLoaded();
  };

  handleImageLoaded = () => {
    // Get dimensions from the actual image element
    if (this.image) {
      const width = this.image.clientWidth;
      const height = this.image.clientHeight;

      // Only mark as loaded if we have valid dimensions
      if (width > 0 && height > 0) {
        this.setState({ dimensionsSet: true });
        this.props.onVerifyElementLoaded(true);
      }
    }
  };

  render() {
    return (
      <img
        className={`text-element__image ${this.state.loaded}`}
        src={this.props.url}
        alt=""
        onLoad={this.handleOnLoad}
        ref={(image) => {
          this.image = image;
        }}
      />
    );
  }
}

export default TextImage;
